import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';
import { IPatientInfo } from '../../ipatient-info';

@Component({
  selector: 'app-address-details',
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule
  ],
  templateUrl: './address-details.component.html',
  styleUrl: './address-details.component.scss'
})
export class AddressDetailsComponent {
  @Input() patientDetails: IPatientInfo | undefined;

  hasAddress(address: any): boolean {
    return !!(
      address?.address1 ||
      address?.address2 ||
      address?.area ||
      address?.taluka ||
      address?.district ||
      address?.pincode ||
      address?.state ||
      address?.country
    );
  }

  getAddress(isPermanent: boolean) {
    const addresses = this.patientDetails?.address || [];
    const matchedAddress = addresses.find(address => address?.isPermanent === isPermanent);

    if (matchedAddress) {
      return matchedAddress;
    }

    return addresses.length === 1 ? addresses[0] : undefined;
  }

  hasAnyAddress(): boolean {
    return this.hasAddress(this.getAddress(true)) || this.hasAddress(this.getAddress(false));
  }
}
